import React from 'react';
import axios from 'axios';
import './ChampIcon.css';

const url = 'https://masteryrace-api.vercel.app/api/summoner/champIcon';
const urlIcons = 'https://ddragon.leagueoflegends.com/cdn/10.16.1/img/champion/';

export default class ChampIcon extends React.Component{
  constructor(props) {
    super(props);
    this.state = { 
      isLoaded: false,
      item: [],
      selectedChampID: "" ,
      selectedChamp: "",
    };
  }

  async componentDidMount() {
    this.setState({ isLoaded: false });
    await axios.get(url)
    .then(
    (data) => {
      this.setState({
        isLoaded: true,
        selectedChampID: data.data.champNameID,
        selectedChamp: data.data.champName
      });
    },
    (error) => {
      this.setState({
        isLoaded: true,
        error
      });
    }
    )
  }
  
  render(){
    return(
      <div className="icon">
        <img src={urlIcons.concat(this.state.selectedChampID).concat(".png")} alt="championIcon" id = "champIcon"></img>
        <h2>{this.state.selectedChamp}</h2>
      </div>  
    )
  }
}